import {
    GET_SUGGESTED_USERS
} from "@/store/actions.type"
import {
    CLEAR_SUGGESTED_USERS
} from "@/store/mutations.type"


export default {
    data: () => ({
        suggestedUsersLoading: false
    }),
    created() {
        this.fetchSuggestedUsers()
    },

    computed: {
        suggestedUsers() {
            return this.$store.state.suggestions.suggestedUsers
        }
    },
    methods: {
        profile() {},

        fetchSuggestedUsers() {

            if (!this.suggestedUsersLoading && !this.$store.state.suggestions.suggestedUsersFetchCompleted) {
                this.suggestedUsersLoading = true
                this.$store.dispatch(GET_SUGGESTED_USERS)
                    .then(() => {
                        this.suggestedUsersLoading = false
                    })
                    .catch(() => {
                        this.suggestedUsersLoading = false
                    })
            }

        },

        scrolledTillBottom(val) {
            if (val) {
                this.fetchSuggestedUsers()
            }
        },

        scrolledTillRight(val) {
            if (val) {
               this.fetchSuggestedUsers()
            }
        }
    },

    destroyed() {
        this.$store.commit(CLEAR_SUGGESTED_USERS)
    }
}